// extracted by mini-css-extract-plugin
export var orderSummary = "_s2-0";
export var showMoreLessButton = "_s2-1";